<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="displayTitle"
      visible
      direction="rtl"
      :size="1000"
      :before-close="() => $refs.main.cancel()"
    >
      <div class="drawer-header">
        {{ displayDesc }}
      </div>
      <div class="drawer-main">
        <div class="drawer-main-wrapper">
          <Main
            ref="main"
            :dfDefinitionCode="dfDefinitionCode"
            :dfCategoryNo="dfCategoryNo"
            @reload="$emit('reload')"
            @close="close()"
          />
          <div class="d-flex justify-content-end mt-2 mb-2">
            <el-button type="primary" size="small" @click="$refs.main.save()">
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    dfDefinitionCode: { type: String, default: '' },
    dfCategoryNo: { type: String, default: '' },
  },
  computed: {
    displayTitle() {
      return this.$l(
        ['drawer_title_editCategoryOptions', this.dfCategoryNo]
          .filter(Boolean)
          .join('_')
      )
    },
    displayDesc() {
      return this.$l(
        ['drawer_desc_editCategoryOptions', this.dfCategoryNo]
          .filter(Boolean)
          .join('_')
      )
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-drawer__body {
    display: flex;
    flex-direction: column;
    .drawer-header {
      font-size: 16px;
      font-weight: bold;
      color: #101010;
      padding: 10px 30px;
      border-bottom: 1px solid #f4f6f9;
    }
    .drawer-main {
      flex-grow: 1;
      position: relative;
      .drawer-main-wrapper {
        padding: 10px 30px 32px;
        position: absolute;
        inset: 0;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
}
</style>
